import {Button, FormControlLabel, IconButton, Switch} from '@material-ui/core';
import {Close} from '@material-ui/icons';
import * as I from 'immutable';
import React from 'react';
import {useDispatch} from 'react-redux';
import AgentNumberInput, {AvailableAgentNumber} from 'Users/components/UserAdministration/UserEntry/AgentNumberInput';
import TaxIdInput from 'Users/components/UserAdministration/UserEntry/TaxIdInput';
import {
  addAgencyAssociation,
  addAgentNumber,
  changeIsAgencyAdministrator,
  changeTaxId,
  removeAgencyAssociation,
  removeAgentNumber,
} from 'Users/ducks/agentUserType';
import {AgencyAssociation} from 'Users/models/User/Agent/AgencyAssociation';
import {AgentNumber} from 'Users/models/User/Agent/AgentNumber';
import {AgentUserType} from 'Users/models/User/Agent/AgentUserType';
import {matchTaxIdentificationNumber} from 'Users/models/User/Agent/TaxIdentificationNumber';
import './AgentPortalEntry.sass';

type AgentPortalEntryProps = {
  agentUserType: AgentUserType;
  isEdit: boolean;
  hasUpdateAccess: boolean;
};

export const AgentPortalEntry = (props: AgentPortalEntryProps) => {
  const dispatch = useDispatch();
  const {agentUserType, hasUpdateAccess, isEdit} = props;
  const agencyAssociations: I.List<AgencyAssociation> = agentUserType.agencyAssociations;

  return (
    <div className="agent-portal-entry-section">
      {agencyAssociations.map(({taxId, isAgencyAdministrator, agentNumbers}, index) => {
        return (
          <div className="agent-portal-entry-section__agency-association-section" key={`association-${index}`}>
            <IconButton
              className="agency-association-section__remove-association-button"
              onClick={() => dispatch(removeAgencyAssociation(index))}
              disabled={!hasUpdateAccess && isEdit}
            >
              <Close />
            </IconButton>
            <h2 className="agency-association-section__agency-association-label">Agency Association {index + 1}</h2>
            <TaxIdInput
              className="agency-association-section__tax-id-input"
              taxId={taxId}
              onChange={taxId => dispatch(changeTaxId(index, taxId))}
              disabled={!hasUpdateAccess && isEdit}
            />
            {matchTaxIdentificationNumber(taxId, {
              ValidTaxIdentificationNumber: ({availableAgentNumbers}) => (
                <AgentNumberInputSection
                  index={index}
                  agentNumbers={agentNumbers}
                  availableAgentNumbers={availableAgentNumbers}
                  isAgencyAdministrator={isAgencyAdministrator}
                  disabled={!hasUpdateAccess && isEdit}
                />
              ),
              ExistingTaxIdentificationNumber: ({availableAgentNumbers}) => (
                <AgentNumberInputSection
                  index={index}
                  agentNumbers={agentNumbers}
                  availableAgentNumbers={availableAgentNumbers}
                  isAgencyAdministrator={isAgencyAdministrator}
                  disabled={!hasUpdateAccess && isEdit}
                />
              ),
              Default: () => null,
            })}
          </div>
        );
      })}
      <Button
        className="agent-portal-entry-section__add-new-association-button"
        color="primary"
        onClick={() => dispatch(addAgencyAssociation())}
        disabled={!hasUpdateAccess && isEdit}
      >
        Add New Association
      </Button>
    </div>
  );
};

type AgentNumberInputSectionProps = {
  isAgencyAdministrator: boolean;
  agentNumbers: AgentNumber[];
  availableAgentNumbers: AvailableAgentNumber[];
  index: number;
  disabled?: boolean;
};

const AgentNumberInputSection = (props: AgentNumberInputSectionProps) => {
  const {availableAgentNumbers, index, agentNumbers, isAgencyAdministrator, disabled} = props;
  const dispatch = useDispatch();

  return (
    <>
      <AgentNumberInput
        className="agency-association-section__agent-number-input"
        agentNumbers={agentNumbers}
        availableAgentNumbers={availableAgentNumbers}
        onAddAgentNumber={({isNewYork, value, status}) =>
          dispatch(addAgentNumber(index, {value, isNewYork, status: {id: status.id, name: status.name}}))
        }
        onRemoveAgentNumber={({isNewYork, value, status}) =>
          dispatch(removeAgentNumber(index, {value, isNewYork, status: {id: status.id, name: status.name}}))
        }
        disabled={!!disabled}
      />
      <p className="agency-association-section__elevated-access-label">Elevated Access:</p>
      <FormControlLabel
        label="Is Agency Administrator?"
        control={
          <Switch
            checked={isAgencyAdministrator}
            onChange={e => dispatch(changeIsAgencyAdministrator(index, e.target.checked))}
            color="primary"
            disabled={!!disabled}
          />
        }
      />
    </>
  );
};
export default AgentPortalEntry;
